import { render } from "./asideFilters.vue?vue&type=template&id=35140b74&scoped=true"
import script from "./asideFilters.vue?vue&type=script&lang=js"
export * from "./asideFilters.vue?vue&type=script&lang=js"

import "./asideFilters.vue?vue&type=style&index=0&id=35140b74&lang=scss&scoped=true"
import "./asideFilters.vue?vue&type=style&index=1&id=35140b74&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35140b74"]])

export default __exports__